// @flow

import { withSearchResult } from 'hocs/search';
import ContractList from './contract-list';

const ContractListWithSearchResult = withSearchResult(ContractList);

export default ContractListWithSearchResult;
